<app-entity-page
[closeClicked]="closeClicked"
[detailsContentTitle]="getDetailsTitle()"
[loading]="manuscriptDetailsIsLoading">
  <ng-template #detailsContent>
    <div class="manuscript-content">
      <div class="manuscript-content-body">
        <manuscript-details 
          class="manuscript-details" 
          [selectedManuscript]="selectedManuscriptDetails" 
          [currentLanguage]="currentLanguage$">
        </manuscript-details>
      </div>
    </div>
  </ng-template>
</app-entity-page>
